import { combineReducers } from "redux";
import initialState from "../state";
import flightData from "./flightData";
import intFlightData from "./intFlightData";
import ticketSort from "./ticketSort";
import ticketSelectedFilters from "./ticketSelectedFilters";
import hotelData from "./hotelData";
import hotelSort from "./hotelSort";
import hotelSelectedFilters from "./hotelSelectedFilters";
import itineraryList from "./itineraryList";
import tourList from "./tourList";
import selectedTicket from "./selectedTicket";

// Combine all reducers.
const appReducer = combineReducers({
    flightData,
    intFlightData,
    ticketSort,
    ticketSelectedFilters,
    hotelData,
    hotelSort,
    hotelSelectedFilters,
    itineraryList,
    tourList,
    selectedTicket,
});

const rootReducer = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === "RESET_STATE") state = initialState;

    return appReducer(state, action);
};
export default rootReducer;
